module.exports = __webpack_public_path__ + "img/eggs-parma.4229abbf.jpg";